import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@els/els-react--badge';

import './CustomerLibraryBadge.scss';

export default function CustomerLibraryBadge({ content }) {
  return (
    <span className="customer-library-badge" aria-hidden="true">
      <Badge className="customer-library-badge__content" content={content} type="subtle" size="eyebrow" />
    </span>
  );
}

CustomerLibraryBadge.propTypes = {
  content: PropTypes.string.isRequired,
};
